export default class LogKeys {
  static LOGGING = 'cb.logging';
  static JS_LOG = 'cbjs.logging';
  static HP_URL = 'hp_url';
  static BEFORE_SEND = 'beforeSend';
  static AFTER_LOAD = 'afterLoad';
  static AFTER_URL_FETCH = 'afterUrlFetch';
  static AFTER_SSO = 'afterSso';
}
